var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mcr-gallery"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('preview-images-gallery',{attrs:{"images-src":_vm.imagesSrc,"lazy-load":true,"setup-gallery-data":_vm.setupGalleryData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }